exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-39ecb672]{font-size:1.2rem;margin:0 !important}.buttons[data-v-39ecb672]{display:flex;justify-content:space-between}", ""]);

// exports
